import { Box, Button, Checkbox, FormControlLabel } from '@mui/material';
import { useState } from 'react';
import { SimpleDialog } from 'src/components/modal';
import { lang } from 'src/utils';

interface CanaryAcknowledgeModalProps {
  open: boolean;
  onAcknowledge: (dontShowAgain: boolean) => void;
}

export const CanaryAcknowledgeModal = ({
  open,
  onAcknowledge,
}: CanaryAcknowledgeModalProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  return (
    <SimpleDialog
      open={open}
      onClose={() => onAcknowledge(dontShowAgain)}
      title={lang.canaryAcknowledgeModal.title}
      subTitle={lang.canaryAcknowledgeModal.subTitle}
      modalSize="sm"
      disableClose
      hideButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mt: 2,
        }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={(event) => setDontShowAgain(event.target.checked)}
            />
          }
          label={lang.canaryAcknowledgeModal.dontShowAgain}
        />
        <Button
          variant="contained"
          disableElevation
          onClick={() => onAcknowledge(dontShowAgain)}
          sx={{
            backgroundColor: '#FFEFD4',
            color: 'rgba(0, 0, 0, 0.87)',
            borderRadius: 0,
            '&:hover': { backgroundColor: '#FEC325' },
          }}>
          {lang.canaryAcknowledgeModal.acknowledge}
        </Button>
      </Box>
    </SimpleDialog>
  );
};
